import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import CountryFlag from 'react-country-flag';
import styled from "styled-components";
import {getFontSize} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {phonePrefixesData} from './phonePrefixesData'

const CustomSelectWrapper = styled.div`
    width: 50%;
	min-width: calc((100% - 24px ) / 2);
	.react-select-phone__menu-list{
		max-height: 170px;
	}	
	.react-select-phone__placeholder{
		color: ${({theme}) => theme.colors.darkDarkBlue};
	}	
	.react-select-phone__menu{
		color: ${({theme}) => theme.colors.darkDarkBlue};
		font-family: ${({theme}) => theme.fontFamily.StrawfordFont};
		font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
		line-height:${getFontSize(16.8, BREAKPOINTS.MOBILE)};
		font-weight: ${({theme}) => theme.fontWeight.medium};
		@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
			font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
			line-height: ${getFontSize(21.6, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
			font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
			line-height: ${getFontSize(21.6, BREAKPOINTS.DESKTOP)};
		}
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        width: 25%;
        min-width: 25%;
    }
`;

const CustomControl = styled.div`
	display: flex;
	align-items: center;
	//padding: 8px;
	padding-left: 38px;
	background-color: ${({theme}) => theme.colors.white};
	border: 1px solid ${({theme}) => theme.colors.darkDarkBlue};
	color: ${({theme}) => theme.colors.darkDarkBlue};
	height: 40px;
	min-height: 40px;
	&.has-value {
		padding-left: 16px;
	}
	font-family: ${({theme}) => theme.fontFamily.StrawfordFont};
	font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
	line-height:${getFontSize(16.8, BREAKPOINTS.MOBILE)};
	font-weight: ${({theme}) => theme.fontWeight.medium};
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
		line-height: ${getFontSize(21.6, BREAKPOINTS.TABLET)};
		height: 50px;
		min-height: 50px;
	}
	@media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
		font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
		line-height: ${getFontSize(21.6, BREAKPOINTS.DESKTOP)};
	}
`;

const CustomOption = styled.div`
  padding: 10px;
  cursor: pointer;
	&::-webkit-scrollbar {
		display: none;
	}
  &:hover {
    background-color: ${({theme}) => theme.colors.basicGrey};
  }
`;

const customComponents = {
	Control: ({ children, ...props }) => {
		const { getValue } = props.selectProps;
		const selectedOption = getValue()[0];
		return (
			<CustomControl className={selectedOption ? 'has-value' : ''} {...props.innerProps}>
				<>
					{selectedOption && (
						<>
							<CountryFlag
								// countryCode={selectedOption.value}
								// countryCode={selectedOption.value}
								countryCode={selectedOption.countryCode}
								svg
								style={{ width: '20px', marginRight: '7px' }}
							/>
							{children}
						</>)}
					{!selectedOption && children}
				</>
			</CustomControl>
		);
	},
	Option: ({ children, ...props }) => {
		return(
			<CustomOption
				{...props.innerProps}
				isSelected={props.isSelected}
				isFocused={props.isFocused}
			>
				<CountryFlag
					countryCode={props.data.value}
					svg
					style={{ width: '20px', marginRight: '8px' }}
				/>
				{children}
			</CustomOption>
		)},
};

const PhonePrefixSelector = ({ value, onChange, placeholder, countryCode }) => {
	const [phonePrefixesOptions, setPhonePrefixesOptions] = useState([]);
	useEffect(() => {
		const loadCountryOptions = () => {
			const options = phonePrefixesData.map(({country, code, iso }) => ({
				value: iso,
				label: `+${code}`,
				prefix: `+${code}`,
				countryCode: countryCode,
			}));
			const polandIndex = options.findIndex(option => option.value === 'PL' || option.label === '+48');
			if (polandIndex > -1) {
				const polandOption = options.splice(polandIndex, 1)[0];
				options.unshift(polandOption);
			}
			setPhonePrefixesOptions(options);
		};

		loadCountryOptions();
	}, [countryCode]);

	return (
		<CustomSelectWrapper>
			<Select
				classNamePrefix="react-select-phone"
				components={customComponents}
				options={phonePrefixesOptions}
				placeholder={placeholder}
				value={phonePrefixesOptions.find((option) => option.prefix === value)}
				onChange={onChange}
				getValue={() => [phonePrefixesOptions.find((option) => option.prefix === value)]}
			/>
		</CustomSelectWrapper>
	);
};

export default PhonePrefixSelector;
